import React, { useEffect, useState } from "react";
import toTitleCase from "../../lib/titleCase/TitleCase";
import "./NewDashboard.css";
import { Badge } from "reactstrap";
import { Col, Modal, Row } from "react-bootstrap";
import { FaUsers } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DashboardUsertitle from "../../data/dashboard/DashboardUsertitle";
import DashboardUserData from "../../data/dashboard/DashboardUserData";
import DataList from "../../components/listDisplay/dataList/DataList";
import NumPagination from "../../components/listDisplay/numPagination/NumPagination";
import DashboardTitle from "../../data/dashboard/DashboardTitle";
import DashBoardData from "../../data/dashboard/DashBoardData";
import { useSelector } from "react-redux";

const HeaderHero = ({ userdetails, userData, greeting }) => {
  const department = userdetails?.emp_department?.[0];
  const navigate = useNavigate();

  const [showM, setShowM] = useState(false);
  const handleCloseM = () => setShowM(false);
  const handleOpenM = () => setShowM(true);

  const [showM2, setShowM2] = useState(false);
  const handleCloseM2 = () => setShowM2(false);
  const handleOpenM2 = () => setShowM2(true);
  const [today_data, settoday_data] = useState("");

  const teamhandel = () => navigate("/ems/users");
  // const presenthandel = () => navigate("/hr/EmpAttendance");
  // const absenthandel = () => navigate("/ems/leave");

  const data_len = useSelector((state) => state.pagination.data_length);
  const page_num = useSelector((state) => state.pagination.page_number);
  const search = useSelector((state) => state.searchbar.search_item);

  return (
    <>
      <Modal show={showM} onHide={handleCloseM} className="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Today's Attendance </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <DataList
              Data_Title={DashboardTitle}
              Data_Format={DashBoardData}
              path={`ems/dashboardattendance/?search=${search}&p=${page_num}&records=${data_len}&type=${today_data}`}
              checkbox="false"
            />
            <NumPagination path={"path"} />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showM2} onHide={handleCloseM2} className="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Today's {today_data} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <DataList
              Data_Title={DashboardUsertitle}
              Data_Format={DashboardUserData}
              path={`ems/dashboardattendance/?search=${search}&p=${page_num}&records=${data_len}&type=${today_data}`}
              checkbox="false"
            />
            <NumPagination path={"path"} />
          </div>
        </Modal.Body>
      </Modal>

      <div className="header-hero-wrapper">
        <div className="header-hero-container">
          <div className="header-hero-profile">
            <img
              src={userdetails?.profile_pic}
              alt="profile"
              className="header-hero-profile-img"
            />
            <div className="header-hero-online" />
          </div>

          <div className="header-hero-greeting">
            <h2 className="header-hero-greeting-text">
              {greeting} {toTitleCase(userdetails?.firstname)}!
            </h2>
            <p className="header-hero-welcome-text">
              {toTitleCase(userdetails?.designation_name)}
              {userdetails?.role_name
                ? `, ${toTitleCase(userdetails.role_name)}`
                : ""}
            </p>
            <p className="header-hero-welcome-text">
              {toTitleCase(userdetails?.home_branch_name)}
            </p>
          </div>
          {userdetails?.is_superuser || department?.name === "HR" ? (
            <div className="time-section">
              <FaUsers className="mr-2" />
              <span
                className="mr-3"
                style={{ cursor: "pointer" }}
                onClick={teamhandel}
              >
                Team: {userData?.user_data} members
              </span>
              <Badge
                color="success"
                style={{ cursor: "pointer" }}
                className="mr-2"
                onClick={() => {
                  // presenthandel();
                  handleOpenM();
                  settoday_data("Present");
                }}
              >
                Present: {userData?.attendance_data}
              </Badge>
              <Badge
                color="danger"
                style={{ cursor: "pointer" }}
                className="mr-2"
                onClick={() => {
                  handleOpenM2();
                  settoday_data("Absence");
                  // presenthandel();
                }}
              >
                Absent: {userData?.total_absence}
              </Badge>
              <Badge
                color="warning"
                style={{ cursor: "pointer" }}
                className="mr-2"
                onClick={() => {
                  // absenthandel();
                  handleOpenM2();
                  settoday_data("Leave");
                }}
              >
                Leave: {userData?.leave_data}
              </Badge>
            </div>
          ) : (
            " "
          )}
          <div className="header-hero-bg" />
        </div>
      </div>
    </>
  );
};

export default HeaderHero;
